import { render, staticRenderFns } from "./seckill-cart-item.vue?vue&type=template&id=5b79a8d4&scoped=true"
import script from "./seckill-cart-item.vue?vue&type=script&lang=js"
export * from "./seckill-cart-item.vue?vue&type=script&lang=js"
import style0 from "./seckill-cart-item.vue?vue&type=style&index=0&id=5b79a8d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b79a8d4",
  null
  
)

export default component.exports